module.exports = __webpack_public_path__ + "static/media/1002099MF.6df3d2d0.jpg";